
import {Vue, Component} from 'vue-property-decorator';

import './style.less';

@Component
export default class PayType extends Vue {

  constructor(props: any) {
    super(props)
  }

  render() {
    return (
      <div class='payType-container'>
        {
          sessionStorage.getItem('isWeixinCent') == 'true' ? (<div class='payType-item border'>
            <div class='payType-item-left'>
              <img class='icon' src={require('@/assets/svg/wx.svg')} alt=""/>
              <div>微信支付</div>
            </div>
            <div>
              <img src={require('@/assets/svg/dg.svg')} alt=""/>
            </div>
          </div>) : (<div class='payType-item border'>
            <div class='payType-item-left'>
              <img class='icon' src={require('@/assets/svg/zfb.svg')} alt=""/>
              <div>支付宝</div>
            </div>
            <div>
              <img src={require('@/assets/svg/dg.svg')} alt=""/>
            </div>
          </div>)
        }

      </div>
    )
  }

}
